import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { paymentMethodsMapping } from '../../config';
import { initiateKlarna, updateKlarna, clearKlarna, klarnaLoaded, klarnaUnloaded } from '../../actions/checkout';

class KlarnaCheckout extends Component {
	static getDerivedStateFromProps(props, state) {
		const centraCheckoutScript = props.centraCheckoutScript;

		if (typeof window !== 'undefined' && centraCheckoutScript && window.CentraCheckout === undefined) {
			const addCheckoutScript = document.createElement('script');
			addCheckoutScript.text = centraCheckoutScript;
			document.body.appendChild(addCheckoutScript);
		}

		if (state.klarnaCheckoutInitiated === false && props.paymentMethod === paymentMethodsMapping.klarnaCheckout) {
			props.initiateKlarna().then(() => props.updateKlarna()).catch((err) => console.log('DEBUG: err', err));
			return {
				klarnaCheckoutInitiated: true,
			};
		}

		return null;
	}

	constructor(props) {
		super(props);

		if (props.refreshPage) window.location = window.location;

		this.state = {
			klarnaCheckoutInitiated: false,
			klarnaCheckoutRendered: false,
		};
	}

	componentDidMount() {
		this.props.klarnaLoaded();
	}

	componentDidUpdate() {
		const checkoutForm = document.getElementById('checkoutForm');
		if (this.props.paymentHTML && checkoutForm && !this.state.klarnaCheckoutRendered) {
			// Insert checkout form.
			const scriptContents = checkoutForm.querySelector('script').innerHTML;
			const d = document.createElement('script');
			d.text = scriptContents;
			document.getElementById('checkoutForm').appendChild(d);

			// Avoid re-rendering where available.
			// eslint-disable-next-line
			this.setState({
				klarnaCheckoutRendered: true,
			});
		}
	}

	componentWillUnmount() {
		this.props.klarnaUnloaded();
	}

	render() {
		const { paymentHTML } = this.props;

		return (
			<div id="checkoutForm" dangerouslySetInnerHTML={{ __html: paymentHTML }} />
		);
	}
}

const mapState = ({ checkout }, { paymentMethod }) => ({
	paymentHTML: checkout.paymentReturn.paymentHTML,
	centraCheckoutScript: checkout.paymentReturn.centraCheckoutScript,
	refreshPage: checkout.klarnaUnloaded,
	paymentMethod,
});

export default hot(module)(connect(mapState, { initiateKlarna, updateKlarna, clearKlarna, klarnaLoaded, klarnaUnloaded })(KlarnaCheckout));
